import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../Common/InputText';
import ColorChooser from '../../Common/ColorChooser';
import Toggle from '../../Common/Toggle/Toggle';
import Tag from '../../Common/Tag/Tag';

const TaskTagForm = (props) => {
    const onTextChange = (e) => {
        props.onFormChange(e.target.name, e.target.value);
    }

    const onToggleChange = (name, value) => {
        props.onFormChange(name, value);
    }

    const onBackgroundColorChange = (color) => {
        props.onFormChange("backgroundColor", color);
    }

    const onFontColorChange = (color) => {
        props.onFormChange("fontColor", color);
    }

    const onFormSubmit = (e) => {
        e.preventDefault();
        props.onSubmit();
        return false;
    }

    return (
        <div className="identifier-form">
            <form noValidate className={props.isFormValid ? "" : "was-validated"} onSubmit={onFormSubmit}>
                <InputText
                    name="name"
                    label="Name"
                    placeholder="Name"
                    type="text"
                    maxLength={50}
                    value={props.projectTag.name}
                    onChange={onTextChange}
                    isRequired={true}
                    errorMessage="Name is required"
                    />
                <div className="mt-2 mb-4">
                    <Toggle name="isActive" text="Active" checked={props.projectTag.isActive} onChange={onToggleChange} />
                </div>
                <ColorChooser
                    name="backgroundColor"
                    title="Background Color"
                    selectedColor={props.projectTag.backgroundColor}
                    onChange={onBackgroundColorChange}
                />
                <ColorChooser
                    name="fontColor"
                    title="Font Color"
                    selectedColor={props.projectTag.fontColor}
                    onChange={onFontColorChange}
                />                
                <div className="mt-5">
                    <span className="me-2">Preview:</span>
                    <Tag 
                        title={props.projectTag.name} 
                        backgroundColor={props.projectTag.backgroundColor}
                        color={props.projectTag.fontColor}
                    />
                </div>
            </form>
        </div>
    );
}


TaskTagForm.propTypes = {
    onFormChange: PropTypes.func.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    projectTag: PropTypes.object
}

export default TaskTagForm;
